export default __webpack_public_path__ + "static/Details-9a516a85bb2f70717d295b699632913a.png";